import React, { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { UserPermission, useUserPermissions } from './user-permissions';
import { routes } from 'app/routes';
import { toastFailure } from 'motion-components';

export const useUserLocationPermissions = () => {
  const { getMenuItemPermissions } = useUserPermissions();
  const location = useLocation<any>();
  const history = useHistory();

  const getRouteName = () => {
    const ret = routes.find((element) => element.path === location.pathname);
    return ret?.name;
  };
  const routeName = getRouteName();
  const permissions = getMenuItemPermissions(routeName) as UserPermission | undefined;

  //   console.log('$$$ loc-perm', location.pathname, routeName, permissions);

  const canAddNew = [
    UserPermission.Full,
    UserPermission.InsertOnly,
    UserPermission.InsertUpdateOnly,
  ].includes(permissions);

  const canEdit = [
    UserPermission.Full,
    UserPermission.InsertOnly,
    UserPermission.InsertUpdateOnly,
  ].includes(permissions);

  const canDelete = [UserPermission.Full].includes(permissions);

  const canView = [
    UserPermission.Full,
    UserPermission.InsertOnly,
    UserPermission.InsertUpdateOnly,
    UserPermission.ViewOnly,
  ].includes(permissions);

  useEffect(() => {
    if (!canView) {
      toastFailure('Δεν σας επιτρέπεται η πρόσβαση σε αυτά τα στοιχεία.');
      history.push({
        pathname: '/',
      });
    }
  }, [canView]);

  return { canAddNew, canEdit, canView, canDelete };
};
